import _ from 'lodash';
import * as actionTypes from 'constants/ActionTypes';
// todo data - rename to items !!! in react components to!
const cargoRequests = (state = {
    data: [],
    isLoaded: false,
    isError: false,
    error: {},
}, action) => {
    switch (action.type) {
    case actionTypes.GET_CARGO_REQUESTS.REQUEST:
        return {
            ...state,
            data: [],
            isLoaded: false,
        };
    case actionTypes.GET_CARGO_REQUESTS.SUCCESS: {
        const data = action.data.data.map((item) => {
            return {
                ...item,
                isUpdate: false,
            };
        });

        return {
            ...state,
            ...action.data,
            isLoaded: true,
            data,
        };
    }
    case actionTypes.GET_CARGO_REQUESTS.FAILURE:
        return {
            ...state,
            isLoaded: true,
        };

    case actionTypes.DELETE_CARGO_REQUEST.REQUEST:
        return {
            ...state,
        };
    case actionTypes.DELETE_CARGO_REQUEST.SUCCESS: {
        const newState = _.cloneDeep(state);

        newState.data.forEach((item) => {
            // todo bad decision :(
            if (item._id === action.cargoRequestId) {
                item.deleteBy = { email: action.email };
                item.deleteAt = new Date();
            }
        });

        return newState;
    }
    case actionTypes.DELETE_CARGO_REQUEST.FAILURE: {
        const newState = _.cloneDeep(state);

        newState.data.forEach((item) => {
            if (item._id === action.cargoRequestId) {
                item.errors = action.errors;
            }
        });

        return newState;
    }

    case actionTypes.UPDATE_CARGO_REQUEST.REQUEST:
        return {
            ...state,
        };
    case actionTypes.UPDATE_CARGO_REQUEST.SUCCESS: {
        const newState = _.cloneDeep(state);

        newState.data.forEach((item) => {
            if (item._id === action.cargoRequestId) {
                item.isUpdate = false;
            }
        });

        return newState;
    }
    case actionTypes.UPDATE_CARGO_REQUEST.FAILURE: {
        const newState = _.cloneDeep(state);

        newState.data.forEach((item) => {
            if (item._id === action.cargoRequestId) {
                item.isUpdate = true;
                item.errors = action.errors;
            }
        });

        return newState;
    }

    case actionTypes.POST_CARGO_REQUEST.REQUEST:
        return {
            ...state,
            data: [],
        };
    case actionTypes.POST_CARGO_REQUEST.SUCCESS: {
        const data = _.cloneDeep(state.data);
        data.push(action.cargoRequest);
        return {
            ...state,
            data,
        };
    }
    case actionTypes.POST_CARGO_REQUEST.FAILURE:
        return {
            ...state,
        };
    default:
        return state;
    }
};

export default cargoRequests;



// WEBPACK FOOTER //
// ./app/reducers/cargoes/requests.js